<div class="container" (click)="$event.stopPropagation()">
	@for (type of documentTypes; track type) {
		<mat-checkbox
			(change)="toggleSelection($event, type)"
			[checked]="isChecked(type)"
			class="au-checkbox"
			color="primary"
		>
			<au-document-type [type]="type" />
		</mat-checkbox>
	}
</div>
